module.exports = __webpack_public_path__ + "static/media/escalation.2d0bbee3.png";